var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-padding"},[_c('div',{staticStyle:{"height":"100%"}},[_c('FormPageConfirmTermsTable',{ref:"terms-table",attrs:{"isEvent":false,"page_item":_vm.local_item},on:{"changed":_vm.changed}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }